import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 2,
        paddingLeft:10,
    },
    guestdetailData: {
        color: '#000',
        fontSize: 7,
        fontWeight:200,
        fontFamily: 'Helvetica-Oblique',
       // marginBottom: 2,
       
    },
  });

const BookingGuest = ({invoice}) => {

   
    
    return ( <View style={styles.headerContainer}>
      <Text style={styles.guestdetailData}>Guest Name:- {invoice.first_name} {invoice.last_name} - (No. of guest - {invoice.guest_count} )</Text>
      {/* <Text  style={styles.guestdetailData}>Contact Number:- {item.contact_number}</Text>
  <Text  style={styles.guestdetailData}>EmailID:-  {item.email}</Text> */}
</View > )
  };
  export default BookingGuest